module.exports = __webpack_public_path__ + "23adb9fe16db7e7f840b59f3d71877d8.svg";